import { Component, OnInit } from '@angular/core';
import { EquipmentService } from '../../_services/equipment.service';
import { ActivatedRoute, Router } from '@angular/router';
import { EquipmentList } from '../../_models/equipment-list';
import { AttendancePlaceService } from '../../_services/attendance-place.service';
import { AttendanceService } from '../../_services/attendance.service';
import { ModalDefaultService } from '../../modal-default/modal-default.service';
import { FormGroup, FormBuilder } from '@angular/forms';
import { EmployeeService } from '../../_services/employee.service';
import { Employee } from '../../_models/employee';
import * as FileSaver from 'file-saver';

@Component({
  selector: 'app-equipment-list',
  templateUrl: './equipment-list.component.html',
  styleUrls: ['./equipment-list.component.css']
})
export class AttendanceEquipmentListComponent implements OnInit {
  loading = false;
  submitted = false;
  equipments: EquipmentList[];
  placeName = '';
  error = '';
  isMobile = false;
  idAttendancePlace = 0;
  year = 0;
  month: 0;
  attendanceSituation;
  idEquipment = 0;
  employeesList: Employee[];
  dateForm: FormGroup;

  constructor(private formBuilder: FormBuilder, private equipmentService: EquipmentService, private attendancePlaceService: AttendancePlaceService, private attendanceService: AttendanceService, private modalService: ModalDefaultService,
    private router: Router, private employeeService: EmployeeService, private activeRoute: ActivatedRoute) { }

  ngOnInit() {

    this.isMobile = this.identifyDevice();

    this.activeRoute.params.subscribe(routeParams => {
      this.idAttendancePlace = routeParams.idAttendancePlace;
      this.year = routeParams.year;
      this.month = routeParams.month;
    });

    this.getAttendancePlace();
    this.getEquipmentsByAttendancePlace();
    this.getEmployees();
  }

  showModal(content, idEquipment) {
    this.loading = true;
    this.submitted = true;

    this.dateForm = this.formBuilder.group({
      startDate: [null], employee: [null]
    });

    this.idEquipment = idEquipment;

    this.attendanceService.getSituation(idEquipment, this.year, this.month)
      .subscribe(
        data => {
          if (data != null) {
            this.attendanceSituation = data;

            this.modalService.openDefault(content, null).result.then(
              (closeResult) => {
                if (closeResult == "send")
                  console.log("modal closed : ", closeResult);
              }, (dismissReason) => {
                //modal Dismiss
                console.log("modal dismissed when used pressed ESC button");
              })
          }

          this.loading = false;
          this.submitted = false;
        },
        error => {
          this.loading = false;
          this.submitted = false;
        });
  }

  notAuthorizedAttendance() {
    this.setAttendance("attendances/equipment/" + this.idEquipment + "/year/" + this.year + "/month/" + this.month + "/notAuthorized", true);
  }

  setAttendance(endpoint, isPostAction) {

    this.submitted = true;
    this.loading = true;

    var dateNow = new Date();

    var startDate = this.dateForm.controls.startDate.value ? new Date(this.dateForm.controls.startDate.value) : null;
    var idEmployee = this.dateForm.controls.employee.value ? this.dateForm.controls.employee.value.id : null;

    if (startDate) {
      startDate.setHours(dateNow.getHours());
      startDate.setMinutes(dateNow.getMinutes());
    }

    this.attendanceService.executeAction(endpoint, isPostAction, startDate, idEmployee)
      .subscribe(
        data => {
          this.modalService.closeDefault();

          if (!data) {
            this.loading = false;
            this.submitted = false;
          }
          else {
            if (data.status == 3) {
              this.router.navigate(['attendance/signature/' + data.id]);
            }
            else
              if (data.status == 4) {
                this.router.navigate(['attendance/list']);
              }
              else {
                this.router.navigate(['attendance/checklistCompletion/' + data.id]);
              }
          }
        },
        error => {
          this.loading = false;
          this.submitted = false;
        });
  }

  private getEquipmentsByAttendancePlace() {

    this.equipmentService.getEquipmentsByAttendancePlace(this.idAttendancePlace, this.year, this.month)
      .subscribe(
        data => {
          this.equipments = data;
        },
        error => {
          this.error = error;
        });
  }

  private getAttendancePlace() {

    this.attendancePlaceService.getAttendancePlace(this.idAttendancePlace)
      .subscribe(
        data => {
          this.placeName = data != null ? data.name.toUpperCase() : "Equipamentos";
        },
        error => {
          this.router.navigate(['attendance/list']);
        });
  }

  private getEmployees() {
    this.employeeService.getEmployeeList()
      .subscribe(
        data => {
          this.employeesList = data;
        },
        error => {
          this.error = error;
        });
  }

  downloadReport(equipment) {

    this.attendanceService.getReportFile(equipment.idLastAttendance)
      .subscribe(
        data => {

          var fileName = this.year + "-" + this.month + "-" + (equipment.idExternal ? equipment.idExternal : equipment.name) + ".pdf";

          FileSaver.saveAs(data, fileName);
        },
        error => {

        });
  }

  identifyDevice() {
    var check = false;
    (function (a) { if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0, 4))) check = true })(navigator.userAgent || navigator.vendor);
    return check;
  }
}
